import { getProductDetailParam, ProductDetail } from '@dh-io-emh/commerce-api/src/models/product';
import { infuse } from '../ioc-config';
import type { TrackingApplication, TrackingLinkClickEvent, TrackingVehicleContext } from '../tracking/tracking.types';
import {
  getCartDataTrackingObject,
  getClickDataTrackingObject,
  getParseBodyTypeCode,
  getProductDataTrackingObject,
  getProductsDataTrackingObject,
} from '../tracking/tracking.utils';
import { Ref } from 'vue';
import Vehicle from '../models/vehicle.model';

export const useTracking = (product?: Ref<ProductDetail | Vehicle>) => {
  const trackingService = infuse('trackingService');
  const alreadyTracked = new Set();

  const trackLinkClickOnce = (
    id: string | symbol,
    eventData: TrackingLinkClickEvent,
    application?: Partial<TrackingApplication>,
  ): Promise<void> | void => {
    if (alreadyTracked.has(id)) return;

    alreadyTracked.add(id);

    return trackingService.trackLinkClick(eventData, application);
  };

  const isDataLayerAlreadyPopulated = (action: string, label: string): Promise<void> | any => {
    return window.dataLayer_ow.find((item) => item.eventDetail?.action === action && item.eventDetail?.label === label);
  };

  const vehicleContext: TrackingVehicleContext | undefined = product?.value
    ? {
        baumusterId: getProductDetailParam(product.value, 'baumuster')!,
        class: undefined,
        bodyType: getParseBodyTypeCode(getProductDetailParam(product.value, 'bodyType')!),
      }
    : undefined;

  return {
    trackPageView: trackingService.trackPageView,
    trackLinkClick: trackingService.trackLinkClick,
    trackLinkClickOnce,
    isDataLayerAlreadyPopulated,
    getProductDataTrackingObject,
    getProductsDataTrackingObject,
    getCartDataTrackingObject,
    getClickDataTrackingObject,
    vehicleContext,
  };
};
